// extracted by mini-css-extract-plugin
export default {"title":"rrT_G1TWD43JNX0vOF8I","subtitle":"x9ENMO78y_bcf2n51T4w"};